import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ColorAnimationService {
  private timeBetweenChange = 10;
  private animationActive = false;
  private hueIndex = 0;
  private hueValues = [0, 180];
  private _hue$ = new BehaviorSubject<string>('');

  hueRotate$ = this._hue$.asObservable();

  runAnimation() {
    if (this.animationActive) {
      return;
    }
    this.animationActive = true;
    this.applyNextHue();
  }

  stopAnimation() {
    // Disable aniamtion and set default hue
    this.animationActive = false;
    this._hue$.next(this.getFilter(this.hueValues[this.hueIndex]));
  }

  private applyNextHue() {
    if (!this.animationActive) {
      return;
    }
    let nextIndex = this.hueIndex + 1;
    if (nextIndex === this.hueValues.length) {
      nextIndex = 0;
    }
    const startHue = this.hueValues[this.hueIndex];
    const targetHue = this.hueValues[nextIndex];
    this.hueIndex = nextIndex;

    this.animateColor(startHue, targetHue, 12000, () => {
      setTimeout(() => {
        this.applyNextHue();
      }, this.timeBetweenChange);
    });
  }

  private animateColor(
    startHue: number,
    targetHue: number,
    animationTime: number,
    done: () => void
  ) {
    let start = 0;

    const loop = (timestamp: number) => {
      if (!this.animationActive) {
        return;
      }
      if (!start) {
        start = timestamp;
      }

      let progress = (timestamp - start) / animationTime;
      if (progress > 1) {
        progress = 1;
      }

      const hue = startHue + progress * (targetHue - startHue);
      if (hue !== targetHue) {
        window.requestAnimationFrame(loop);
      } else {
        done();
      }

      this._hue$.next(this.getFilter(hue));
    };

    requestAnimationFrame(loop);
  }

  getFilter(hue: number) {
    return `hue-rotate(${hue}deg)`;
  }
}
